module.exports = __webpack_public_path__ + "img/locations_layout5.f2ea07b6.png";